import { render, staticRenderFns } from "./customField.vue?vue&type=template&id=4f5ad054&"
import script from "./customField.vue?vue&type=script&lang=js&"
export * from "./customField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports